import React from "react";
import { Box, BoxProps } from "@mui/material";

type DefaultSiteIconProps = BoxProps & {
  size?: number;
  label?: string;
};

const DefaultSiteIcon = ({ size = 48, label = "S icon with FLESHMAN arc", sx, ...rest }: DefaultSiteIconProps) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    role="img"
    aria-label={label}
    sx={{
      width: size,
      height: size,
      color: "primary.main",
      ...sx
    }}
    {...rest}
  >
    <defs>
      <path id="arc-bottom-centered" d="M 18 50 A 32 32 0 0 0 82 50" />
    </defs>
    <circle cx="50" cy="50" r="44" fill="none" stroke="currentColor" strokeWidth="6" />
    <text
      x="50"
      y="54"
      textAnchor="middle"
      dominantBaseline="middle"
      fontFamily="system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
      fontSize="44"
      fontWeight="800"
      fill="currentColor"
    >
      S
    </text>
    <text
      fontFamily="system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
      fontSize="7"
      fontWeight="700"
      letterSpacing="0.5"
      fill="currentColor"
    >
      <textPath href="#arc-bottom-centered" startOffset="50%" textAnchor="middle">
        FLESHMAN
      </textPath>
    </text>
  </Box>
);

export default DefaultSiteIcon;
